<template>
  <ValidationProvider
    ref="officer"
    v-slot="{ errors }"
    name="officer"
    rules="required"
    :vid="vOfficer"
  >
    <BFormGroup
      label-class="font-weight-bolder"
      class="mb-0"
      :label-for="vOfficer"
    >
      <VSelect
        v-model="proxyValue"
        placeholder="search officer here"
        label="officer_name"
        clearable
        append-to-body
        select-on-tab
        :input-id="vOfficer"
        :options="options"
        :loading="(fetching)"
        :disabled="(fetching)"
        :tabindex="(index + 1)"
        :map-keydown="mapKeyDown"
        :calculate-position="calculateDropPosition"
        :class="['border-0', { 'is-invalid': errors.length > 0 }]"
        @option:selected="() => $emit('selected', proxyValue, index)"
      >
        <template #selected-option="{ officer_name }">
          <div
            class="text-break text-wrap"
            style="font-size: 13px;"
            v-text="officer_name"
          />
        </template>

        <template #option="{ officer_name }">
          <div
            class="text-break text-wrap"
            style="font-size: 13px;"
            v-text="officer_name"
          />
        </template>

        <template #no-options="">
          no available officer
        </template>
      </VSelect>
      <div
        v-if="(errors.length > 0)"
        class="invalid-feedback"
        v-text="errors[0]"
      />
    </BFormGroup>
  </ValidationProvider>
</template>
<script>
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

export default {
  name: 'ASMCustomerMemosOfficer',

  mixins: [
    MISC,
    FORMATTER
  ],

  props: {
    value: {
      type: [String, Number, Object],
      default: ''
    },
    index: {
      type: Number,
      default: () => 0,
      required: true
    },
    fetching: {
      type: Boolean,
      default: () => false
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  emits: [
    'input',
    'selected'
  ],

  data () {
    return {
      proxyValue: null
    }
  },

  computed: {
    vOfficer () {
      return `customer_memos.${this.index}.officer`
    }
  },

  watch: {
    value (val) {
      this.proxyValue = val
    },

    proxyValue (val) {
      this.$emit('input', val)
    }
  },

  methods: {
    mapKeyDown (map, context) {
      return {
        ...map,
        // 8: ({ target }) => {
        //   if (target.value === null || target.value === '') {
        //     this.removed()
        //   }
        //   return context.maybeDeleteValue()
        // },
        9: () => {
          if (context.open) {
            return context.onTab()
          }

          return null
        },
        13: evt => {
          evt.preventDefault()
          return context.typeAheadSelect()
        }
      }
    }

    // removed () {
    //   this.$emit('removed', this.item, this.index, true)
    // },
  }
}
</script>
<style scoped>
.v-select {
  background: transparent;
}
</style>
